import { render, staticRenderFns } from "./SpecialShipSettings.vue?vue&type=template&id=589e209a&scoped=true&"
import script from "./SpecialShipSettings.vue?vue&type=script&lang=js&"
export * from "./SpecialShipSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589e209a",
  null
  
)

export default component.exports